export class FieldInfo {
    TableId: string;
    TableName: string;
    ColumnName: string;
    ColumnType: string;
    IsMetric: boolean;
    IsCurrency: boolean;
    IsCommon: boolean;
}
